"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
class Layer {
    constructor(name, version, features) {
        this.feature = (i) => {
            if (i < 0 || i >= this.length)
                throw new Error('feature index out of bounds');
            return this.features[i];
        };
        this.name = name;
        this.length = features.length;
        this.features = features;
        this.version = version;
    }
}
exports.Layer = Layer;
//# sourceMappingURL=Layer.js.map